const NewSmsCampaignsMain = () => import(/* webpackChunkName: "new-sms" */ '@/pages/newSmsCampaigns/main');
const NewSmsCampaignsCreate = () => import(/* webpackChunkName: "new-sms" */ '@/pages/newSmsCampaigns/createCampaign');
const NewSmsCampaignsAnalytics = () => import(/* webpackChunkName: "new-sms-analytics" */ '@/pages/newSmsCampaigns/campaignAnalytics');

export default [
  {
    path: 'sms-campaigns',
    name: 'SMS Campaigns',
    component: NewSmsCampaignsMain,
  },
  {
    path: 'sms-campaigns/analytics/:campaign_id?',
    name: 'SMS Campaigns / Analytics',
    component: NewSmsCampaignsAnalytics,
  },
  {
    path: 'sms-campaigns/create/:campaign_id?',
    name: 'SMS Campaigns / Create',
    component: NewSmsCampaignsCreate,
  },
  {
    path: 'sms-campaigns/edit/:campaign_id?',
    name: 'SMS Campaigns / Edit',
    component: NewSmsCampaignsCreate,
  },
  {
    path: 'sms-campaigns/forward/:campaign_id?',
    name: 'SMS Campaigns / Forward',
    component: NewSmsCampaignsCreate,
  },
];
